module.exports = __webpack_public_path__ + "static/media/TN-Women-Earrings.13c0035d.svg";